import { anim, stagger } from '../../../motion'
import { Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'
import { Badges, Counter } from '../../kit'

// Drei große Zähler auf Blau, darunter die Siegel
export default function DemoScience() {
  const c = useCopy('wissenschaft')

  return (
    <div className='cin-center dm-science'>
      <h2 className='cin-title cin-title--center'>
        <Words text={c.title} at={[0, 0.16]} dim={0.3} />
      </h2>
      <Line at={[0.12, 0.2]} y={20} className='dm-science__sub'>
        {c.sub}
      </Line>
      <div className='dm-science__stats'>
        {c.stats.map((s, i) => (
          <div
            key={s.label}
            className='dm-science__stat'
            style={anim({ at: stagger(0.2, 0.06, 0.1, i), y: 60 })}
          >
            <Counter
              to={s.to}
              at={stagger(0.22, 0.06, 0.26, i)}
              suffix={s.suffix}
              className='dm-science__num'
            />
            <div className='dm-science__label'>{s.label}</div>
          </div>
        ))}
      </div>
      <Badges
        items={c.badges}
        light
        className='dm-science__badges'
        style={anim({ at: [0.62, 0.7], y: 30 })}
      />
    </div>
  )
}
